<template>
  <a-form-item
    v-if="data && options"
    :label="data.fieldname"
    class="cascader"
  >
    <slot />
    <div
      v-decorator="[`${data.fieldkey}`, {
        rules: [{
          required: data.isneeded === 1,
          type: 'array',
          message: placeholder
        }],
        initialValue: defaultValue
      }]"
      class="wrap"
    >
      <a-cascader
        :value="defaultValue"
        :show-search="true"
        :options="options"
        :disabled="!!data.disabled"
        :change-on-select="!isMustLast"
        :placeholder="placeholder"
        :not-found-content="$t('message[1972]')"
        @change="onChange"
      />
    </div>
    <slot name="relate-list" />
    <slot name="after" />
  </a-form-item>
</template>

<script>

export default {
  inject: {
    myForm: {
      type: Object,
      default: null
    }
  },
  props: {
    value: {
      type: Array,
      default: () => null
    },
    data: {
      type: Object,
      default: () => { }
    },
    getData: {
      type: Function,
      default: () => { }
    },
    label: {
      type: String,
      default: ''
    },
    inputTruename: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      defaultValue: [],
      options: null,
      placeholder: ''
    }
  },
  computed: {
    isCreatePage () {
      return this.$route.name === 'InqueryCreate'
    },
    isAuditPage () {
      return this.$route.name === 'InqueryDetail' && this.auditStatus !== 1
    },
    auditStatus () {
      const { audit_status: auditStatus } = this.memberInfo || {}
      return auditStatus
    },
    isMustLast () { // 是否必须选到末级,默认true
      let { isMustLast } = this.data || {}
      if (isMustLast === undefined || isMustLast === true) {
        isMustLast = true
      } else {
        isMustLast = false
      }
      return isMustLast
    }
  },

  watch: {
    value: {
      handler (val) {
        // if (val && val.length) {
        let { fieldkey = '' } = this.data || {}
        this.defaultValue = val

        this.myForm && this.myForm.setFieldsValue({
          [fieldkey]: this.defaultValue
        })
        // }
      },
      immediate: true
    }
  },
  async created () {
    this.init()
    this.setPlaceholder()
  },
  methods: {
    async loadData () {
      const { fieldkey = '' } = this.data || {}
      const data = await this.getData({ fieldkey })

      return data
    },
    setOptions (options) {
      for (let item of options) {
        item.label = item.name || item.fieldname
        let value = item.id === undefined ? item.fieldkey : item.id
        if (item.keyname) {
          item.value = value + '-' + item.keyname
        } else {
          item.value = value
        }

        item.key = item.pId + '-' + item.value
        item.children = item.children || item.child || []
        if (!item.children.length) {
          delete item.children
        }
        if (item.children && item.children.length) {
          item.children = item.children.filter(o => o && o.status !== -7)
          for (let child of item.children) {
            child.pId = item.pId + '-' + (item.id || item.fieldkey)
          }
          this.setOptions(item.children)
        }
      }
      this.options = options
      this.$forceUpdate()
    },
    init () {
      let { fieldtype, fieldvalue } = this.data || {}
      if (this.value && this.value.length) {
        this.defaultValue = this.value
      } else if (fieldtype === 'select_reception') {
        this.defaultValue = fieldvalue || []
        /* if (this.$toType(this.defaultValue) === 'string') {
          this.defaultValue = []
        } */
      } else {
        this.defaultValue = this.setDefaultValue(this.data)
      }

      this.setDefaultOptionsList().then(res => {
        this.resetData(res)
      })
    },
    /** fieldkey === 'dev'
     * 用来过滤不合法的数据（默认值不在列表选项内，包含已离职，转组等情况）
     */
    resetData (res) {
      let { info = {}, fieldkey } = this.data || {}
      let { userid = 0, groupid = 0, roleid = 0 } = info
      let flag = true
      if (this.defaultValue.length === 1) {
        if ((res.findIndex(item => item.id === userid)) === -1) {
          if (this.data.info) {
            this.data.info.userid = 0
          }
        }
      } else if (this.defaultValue.length === 3) {
        let currRoleItem = res.find(item => item.id === roleid)
        let currGroupItem = currRoleItem && currRoleItem.children.find(item => item.id === groupid)

        if (!currRoleItem) {
          flag = false
        }
        if (currRoleItem && !currGroupItem) {
          flag = false
        }

        if (currGroupItem && currGroupItem.children && currGroupItem.children.findIndex(item => item.id === userid) === -1) {
          flag = false
        }
      }
      if (!flag && fieldkey === 'dev' && this.data.info) {
        this.data.info.roleid = 0
        this.data.info.groupid = 0
        this.data.info.userid = 0

        this.data.fieldvalue = []
        this.defaultValue = []

        this.$emit('change', this.data)
      }
    },
    async setDefaultOptionsList () {
      return new Promise(async (resolve, reject) => {
        let loadOptions = await this.loadData()

        const { options, child } = this.data

        this.options = loadOptions || options || child || []

        if (this.options && this.options.length) {
          for (let item of this.options) {
            item.pId = '0'
          }
          this.setOptions(this.options)

          resolve(this.options)
        }
      })
    },
    /**
     * 处理默认value值
     */
    setDefaultValue (item = {}) {
      let arr = []
      const { info = {} } = item
      let { roleid = 0, groupid = 0, userid = 0, divide_type: divideType, type_num: typeNum } = info

      // 如果是审核页面
      // 审核页的录入人员不是万能表单
      if ((this.isAuditPage && this.inputTruename.indexOf('万能表单自动录入') === -1) && !roleid && !userid) {
        roleid = 'null'
      }
      if (roleid) {
        arr.push(`${roleid}-roleid`)
      }
      if (groupid) {
        arr.push(`${groupid}-groupid`)
      }
      /* if (userid) {
        arr.push(`${userid}-userid`)
      } */
      // typeNum=2 四级
      if (typeNum) {
        if (divideType === 1 && typeNum >= 2 && userid) {
          arr.push(`${divideType}-divide_type`)
          arr.push(`${userid}-userid`)
        } else if (userid && (!divideType || typeNum === 1)) {
          arr.push(`${userid}-userid`)
        } else if (divideType) {
          arr.push(`${divideType}-divide_type`)
        }
      } else {
        if (divideType === 1 && userid) {
          arr.push(`${divideType}-divide_type`)
          arr.push(`${userid}-userid`)
        } else if (userid && !divideType) {
          arr.push(`${userid}-userid`)
        } else if (divideType) {
          arr.push(`${divideType}-divide_type`)
        }
      }

      return arr
    },
    setPlaceholder () {
      if (!this.data) return
      let { fieldname = '', fieldconfig = {}, is_shared: isShared } = this.data || {}
      const { placeholder = '' } = fieldconfig
      let spaceStr = this.$isEnglish ? ' ' : ''

      fieldname = isShared ? this.$t('message["1727"]') : fieldname
      let string = placeholder || this.$t('message["855"]') + spaceStr + fieldname
      this.placeholder = string
    },
    onChange (value, selectedOptions) {
      const { fieldkey, fieldtype } = this.data
      // console.log(selectedOptions)
      this.defaultValue = value
      this.data.fieldvalue = value
      if (!value.length) {
        this.data.info = {}
      }

      if (fieldkey === 'from_info' || fieldtype === 'select_reception') {
        this.data.value = []
        if (selectedOptions && selectedOptions.length) {
          selectedOptions.forEach(item => {
            this.data.value.push(item.id)
          })
        }
      } else {
        if (selectedOptions && selectedOptions.length) {
          this.data.info = {}
          selectedOptions.forEach(item => {
            let { value = '' } = item
            this.data.info[item.keyname] = value && value.split('-') && value.split('-')[0]
          })
        }
      }

      this.$emit('change', this.data)

      this.myForm && this.myForm.setFieldsValue({
        [fieldkey]: this.data.fieldvalue
      })
      this.myForm && this.myForm.validateFields([fieldkey], this.validatedCallback)
    },
    validatedCallback (err, values) {
      if (!err) {
        // this.$emit('change', this.data)
      }
    },
    clearCascader () {
      this.defaultValue = []
      this.data.fieldvalue = []
      this.data.info = {}
    },
    updateFollowOptions (options, isShared) {
      this.setOptions(options)
      this.data.is_shared = isShared
      this.setPlaceholder()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
